import React, {Component} from 'react';
import classNames from 'classnames';

// Components
import CreatorOptInAnalysis from './creator_opt_in_analysis';
import CreatorOptOutAnalysis from './creator_opt_out_analysis';

class CreatorParticipationAnalytics extends Component {
    constructor() {
        super();
        this.state = {
            showOptIn: true
        };
    }

    showOptInAnalytics = () => {
        this.setState({
            showOptIn: true
        });
    };

    showOptOutAnalytics = () => {
        this.setState({
            showOptIn: false
        });
    };

    displayTitle = () => (
        <div className="creator-participation-analytics-header-container">
            <div className="creator-participation-analytics-header-title">
                Creator Participation Analysis
            </div>
            <div className="creator-participation-analytics-header-subtitle">
                {
                    'See what type of creators are opting into your campaigns, and what Creators are choosing not to participate.'
                }
            </div>
        </div>
    );

    displayCreatorAnalysis = () => {
        const {bgColor, renderForPdf, getAssetPath} = this.props;
        const {showOptIn} = this.state;
        const title = this.displayTitle();

        if (renderForPdf) {
            return (
                <div id="creator-participation-analytics-pdf">
                    <CreatorOptInAnalysis
                        optedInData={this.props.creatorAnalysis.opted_in}
                        renderForPdf={renderForPdf}
                        getAssetPath={getAssetPath}
                        bgColor={bgColor}
                    />
                    {title}
                    <CreatorOptOutAnalysis
                        optedOutData={this.props.creatorAnalysis.opted_out}
                        renderForPdf={renderForPdf}
                        getAssetPath={getAssetPath}
                        bgColor={bgColor}
                    />
                </div>
            );
        }

        return showOptIn ? (
            <CreatorOptInAnalysis
                optedInData={this.props.creatorAnalysis.opted_in}
                renderForPdf={renderForPdf}
                getAssetPath={getAssetPath}
                bgColor={bgColor}
            />
        ) : (
            <CreatorOptOutAnalysis
                optedOutData={this.props.creatorAnalysis.opted_out}
                renderForPdf={renderForPdf}
                getAssetPath={getAssetPath}
                bgColor={bgColor}
            />
        );
    };

    displayOptInOptOut = () => {
        const {renderForPdf} = this.props;
        const {showOptIn} = this.state;

        const creatorOptInClasses = classNames('opt-in-link', 'creator-opt-in', {
            'opt-in-link-active': showOptIn
        });
        const creatorOptOutClasses = classNames('opt-in-link', {
            'opt-in-link-active': !showOptIn
        });

        if (!renderForPdf) {
            return (
                <div className="creator-opt-in-opt-out-section">
                    <div className={creatorOptInClasses} onClick={this.showOptInAnalytics}>
                        CREATOR OPT IN ANALYSIS
                    </div>
                    <div className={creatorOptOutClasses} onClick={this.showOptOutAnalytics}>
                        CREATOR OPT OUT ANALYSIS
                    </div>
                </div>
            );
        }
    };

    render() {
        const {bgColor, renderForPdf} = this.props;
        const title = this.displayTitle();
        const optInOptOutSelector = this.displayOptInOptOut();
        const creatorAnalysis = this.displayCreatorAnalysis();

        return (
            <div className="creator-participation-analytics wrap-up-section">
                {title}
                {optInOptOutSelector}
                {creatorAnalysis}

                {/*STYLES*/}

                <style>{`
                .creator-participation-analytics {
                    background-color: ${bgColor};
                }

                .creator-participation-analytics-header-title {
                    font-size: 36px;
                    font-weight: 200;
                    padding-top: 40px;
                }

                .creator-participation-analytics-header-subtitle {
                    width: 85%;
                    font-size: 20px;
                    font-weight: 200;
                    text-align: center;
                    padding: 10px 0px 40px 0px;
                }

                .creator-opt-in-opt-out-section {
                    width: 370px;
                    background-color: ${bgColor};
                    border-radius: 50px;
                }

                .opt-in-link {
                    width: 185px;
                    font-size: 18px;
                    font-weight: bold;
                    color: #2c97de;
                    text-align: center;
                    padding: 20px;
                    cursor: pointer;
                    border-radius: 50px;
                }

                .opt-in-link-active {
                    background-color: #2c97de;
                    color: white;
                }
            `}</style>

                {/*STYLE FOR WEB*/}
                {!renderForPdf ? (
                    <style>{`
                        .creator-participation-analytics {
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                        }

                        .creator-participation-analytics-header-container {
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            align-items: center;
                        }

                        .creator-opt-in-opt-out-section {
                            display: flex;
                            justify-content: center;
                            align-items: center;
                        }
                `}</style>
                ) : null}

                {/*STYLE FOR PDF*/}
                {renderForPdf ? (
                    <style>{`
                        .creator-participation-analytics {
                            text-align: center;
                        }

                        .creator-participation-analytics-header-container {
                            text-align: center;
                            page-break-before: always;
                            padding-top: 20px;
                        }

                        .creator-participation-analytics-header-subtitle {
                            margin: auto;
                        }
                `}</style>
                ) : null}
            </div>
        );
    }
}

CreatorParticipationAnalytics.propTypes = {};

export default CreatorParticipationAnalytics;



// WEBPACK FOOTER //
// ./campaign_analytics/campaign_wrap_up/creator_participation_analytics/index.js